import { Responsive } from '@cian/ui-kit';
import * as React from 'react';
import { BlockHeader } from '../../components/BlockHeader';
import { ContentWrapper } from '../../components/ContentWrapper';
import { LandingBlock } from '../../components/LandingBlock';
import { REAL_ESTATE_TYPE_TABS } from '../../constants/suburban';
import { ApplicationContext } from '../../reactContexts/applicationContext';
import { MortgageProgramItems } from '../../SuburbanComponents/MortgageProgramItems';
import { MortgageProgramTable } from '../../SuburbanComponents/MortgageProgramTable';
import { RealEstateTabs } from '../../SuburbanComponents/RealEstateTabs';
import { ScrollableContentWrapper } from '../../SuburbanComponents/ScrollableContentWrapper';
import { TMortgagePrograms, ERealEstateType, EProgramType } from '../../types/suburban';
import { DEFAULT_PROGRAMS } from './constants';
import { trackProgramClick, trackRealEstateTabClick } from './tracking';

export const SuburbanMortgageProgramsContainer = () => {
  const { config } = React.useContext(ApplicationContext);

  const [activeTab, setActiveTab] = React.useState(ERealEstateType.HOUSE);

  const handleTabChange = React.useCallback(
    (id: ERealEstateType) => (e: React.MouseEvent<HTMLButtonElement>) => {
      (e.target as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

      setActiveTab(id);

      trackRealEstateTabClick(REAL_ESTATE_TYPE_TABS[id]);
    },
    [],
  );

  const data = config.get<TMortgagePrograms>('mortgageLanding.programs') || DEFAULT_PROGRAMS;

  const handleProgramClick = React.useCallback(
    (programId?: EProgramType) => {
      const tabName = REAL_ESTATE_TYPE_TABS[activeTab];

      const programName = programId && data[activeTab].find(({ id }) => id === programId)?.name;

      trackProgramClick(tabName, programName);
    },
    [activeTab, data],
  );

  return (
    <LandingBlock>
      <ContentWrapper>
        <BlockHeader>Ипотечные программы</BlockHeader>
      </ContentWrapper>
      <ScrollableContentWrapper>
        <RealEstateTabs activeTab={activeTab} onTabChange={handleTabChange} />
      </ScrollableContentWrapper>
      <ContentWrapper>
        <Responsive desktop>
          <MortgageProgramTable items={data[activeTab]} onButtonClick={handleProgramClick} />
        </Responsive>
        <Responsive tablet phone>
          <MortgageProgramItems items={data[activeTab]} section={activeTab} onButtonClick={handleProgramClick} />
        </Responsive>
      </ContentWrapper>
    </LandingBlock>
  );
};
